import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withPropsOnChange from 'recompose/withPropsOnChange';
import renderNothing from 'recompose/renderNothing';
import { getPayments } from '../reducer/payments/selectors';
import { getCanCheckout } from '../../validated/selectors';
import { checkoutSale, processCharge } from '../actions';
import { setFetching } from '../reducer/isFetching/actions';

const CheckoutSaleContainer = compose(
  connect(
    state => ({
      canCheckout: getCanCheckout(state),
      payments: getPayments(state),
    }),
    { checkoutSale, processCharge, setFetching }
  ),
  withPropsOnChange(
    ['canCheckout'],
    (props) => {
      if (props.canCheckout && props.payments.length > 0) {
        props.setFetching(true);
        props.checkoutSale();
      }
    }
  )
);

export default CheckoutSaleContainer(renderNothing());
